import { useQuery } from '@tanstack/react-query';
import { FormControlLabel, MenuItem, Stack, Switch, TextField } from '@mui/material';

import { useApplicationFormApi } from './applicationFormApi';
import { SearchableLookupField } from '../../leads/wizard/SearchableLookupField';
import { WizardValues } from './wizardTypes';

interface Step7Props {
  values: WizardValues;
  setField: <K extends keyof WizardValues>(field: K, value: WizardValues[K]) => void;
}

export const Step7VisaHistory = ({ values, setField }: Step7Props) => {
  const { listLookup } = useApplicationFormApi();
  const countriesQuery = useQuery({
    queryKey: ['lookup', '/master-data/countries'],
    queryFn: () => listLookup('/master-data/countries', { activeOnly: true }),
  });

  return (
    <Stack spacing={2}>
      <FormControlLabel
        control={
          <Switch
            checked={values.visaAppliedBefore}
            onChange={(e) => setField('visaAppliedBefore', e.target.checked)}
          />
        }
        label="Applied for a visa before"
      />
      <FormControlLabel
        control={<Switch checked={values.visaRefused} onChange={(e) => setField('visaRefused', e.target.checked)} />}
        label="Visa refused"
      />

      {values.visaRefused && (
        <>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <SearchableLookupField
              label="Country"
              options={countriesQuery.data}
              value={values.visaRefusedCountryId}
              onChange={(id) => setField('visaRefusedCountryId', id)}
            />
            <TextField
              select
              label="Visa type"
              fullWidth
              value={values.visaType}
              onChange={(e) => setField('visaType', e.target.value as WizardValues['visaType'])}
            >
              <MenuItem value="">
                <em>Not specified</em>
              </MenuItem>
              <MenuItem value="STUDENT">Student</MenuItem>
              <MenuItem value="TOURIST">Tourist</MenuItem>
              <MenuItem value="WORK">Work</MenuItem>
              <MenuItem value="VISIT">Visit</MenuItem>
              <MenuItem value="OTHER">Other</MenuItem>
            </TextField>
          </Stack>
          <TextField
            label="Reason for refusal"
            fullWidth
            multiline
            minRows={2}
            value={values.visaRefusalReason}
            onChange={(e) => setField('visaRefusalReason', e.target.value)}
          />
        </>
      )}

      <TextField
        label="Comments"
        fullWidth
        multiline
        minRows={2}
        value={values.visaComments}
        onChange={(e) => setField('visaComments', e.target.value)}
      />
      <TextField
        label="Travel history"
        fullWidth
        multiline
        minRows={3}
        value={values.travelHistory}
        onChange={(e) => setField('travelHistory', e.target.value)}
      />
    </Stack>
  );
};
